import React from 'react';

interface IconProps {
  width?: number;
  height?: number;
  style?: React.CSSProperties;
}

export const FaceEerieIcon: React.FC<IconProps> = ({ width = 32, height = 32, style }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
      <path
        d="M29.9978 15.9989C29.9978 23.7303 25.3333 29.9978 15.9989 29.9978C6.66443 29.9978 2 23.7303 2 15.9989C2 15.3202 2.03594 14.6528 2.10783 14L15.9989 8L29.8899 14C29.9618 14.6528 29.9978 15.3202 29.9978 15.9989Z"
        fill="#FFB02E"
      />
      <path d="M29.89 14C29.143 7.21549 24.514 2 15.999 2C7.48389 2 2.85495 7.21549 2.10791 14H29.89Z" fill="#5092FF" />
      <path
        d="M10.5 16C12.9853 16 15 13.9853 15 11.5C15 9.01472 12.9853 7 10.5 7C8.01472 7 6 9.01472 6 11.5C6 13.9853 8.01472 16 10.5 16Z"
        fill="white"
      />
      <path
        d="M21.5 16C23.9853 16 26 13.9853 26 11.5C26 9.01472 23.9853 7 21.5 7C19.0147 7 17 9.01472 17 11.5C17 13.9853 19.0147 16 21.5 16Z"
        fill="white"
      />
      <path
        d="M13 21C13 19.3431 14.3431 18 16 18C17.6569 18 19 19.3431 19 21V24C19 25.6569 17.6569 27 16 27C14.3431 27 13 25.6569 13 24V21Z"
        fill="#BB1D80"
      />
      <path
        d="M1 18.5V23.881C1 25.2484 1.48914 26.5707 2.37902 27.6089L3.95015 29.4418C5.55328 31.3122 8.44672 31.3122 10.0498 29.4418C11.6183 27.6119 11.2335 24.8223 9.22817 23.4854L4.71495 20.4766C4.26829 20.1789 4 19.6776 4 19.1407V18.5C4 17.6716 3.32843 17 2.5 17C1.67157 17 1 17.6716 1 18.5Z"
        fill="#FF822D"
      />
      <path
        d="M31.0654 18.5V23.881C31.0654 25.2484 30.5763 26.5707 29.6864 27.6089L28.1153 29.4418C26.5122 31.3122 23.6187 31.3122 22.0156 29.4418C20.4471 27.6119 20.8319 24.8223 22.8373 23.4854L27.3505 20.4766C27.7971 20.1789 28.0654 19.6776 28.0654 19.1407V18.5C28.0654 17.6716 28.737 17 29.5654 17C30.3939 17 31.0654 17.6716 31.0654 18.5Z"
        fill="#FF822D"
      />
    </svg>
  );
};
